import {
  Container,
  RowEdit,
  SearchRow,
  LineTable,
  CellLine,
  AlignButtonSearch,
  TableContent,
} from "./style";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Api from "../../../../adapters/api/api";

import { Table, Button, Input, FormGroup, Col, Row } from "reactstrap";
import { FiPlus } from "react-icons/fi";
import { useToast } from "../../../../hooks/Toast";

export const Users: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [users, setUsers] = useState<Array<Object>>([]);
  const [query, setQuery] = useState({
    type_search: "email",
    value: "",
  });

  useEffect(() => {
    loadUsers();
  }, []);

  const handleTypeSearchChange = (event: React.ChangeEvent<any>) => {
    setQuery((prev) => ({
      ...prev,
      type_search: event.target.value,
    }));
  };

  const loadUsers = async () => {
    try {
      let queryString = "";
      if (query.value) {
        queryString = `?${query.type_search}=${encodeURIComponent(
          query.value
        )}`;
      }

      const response = await Api.get(`/admin/user${queryString}`);
      setUsers(response.data);
    } catch (err: any) {
      const responseData = err.response?.data;

      if (err.response?.status === 422 && responseData?.data) {
        const message = Object.entries(responseData.data)
          .map(([field, error]) => `${field} - ${error}`)
          .join(", ");

        addToast({
          title: responseData.message || "Parâmetros inválidos",
          description: message,
          type: "error",
        });
      } else {
        addToast({
          title: "Erro ao buscar usuários",
          description:
            "Ocorreu um erro inesperado ao processar sua requisição. Tente novamente mais tarde.",
          type: "error",
        });
      }
    }
  };

  const searchAddress = async (event: any) => {
    event.preventDefault();

    const search = event.target[0].value;
    const type = event.target[1].value;

    // const adresses = await Api.get(`address?search=${search}&type=${type}`);
    // setAddress(adresses.data);
  };

  const handleClick = (profile_id: string) => {
    navigate(`/users/${profile_id}/profile`);
  };

  return (
    <>
      <Container>
        <div>
          <SearchRow>
            <form onSubmit={searchAddress}>
              <Row>
                <Col col={12} sm={12} md={8}>
                  <FormGroup>
                    <Input
                      name="search"
                      placeholder="Digite sua busca"
                      onChange={(e) =>
                        setQuery((prev) => ({ ...prev, value: e.target.value }))
                      }
                    />
                  </FormGroup>
                </Col>
                <Col col={12} sm={12} md={2}>
                  <FormGroup>
                    <Input
                      id="type_search"
                      name="type_search"
                      type="select"
                      value={query.type_search}
                      onChange={handleTypeSearchChange}
                    >
                      <option value="email">Email</option>
                      <option value="document">Documento</option>
                      <option value="phone">Celular</option>
                      <option value="id">ID</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col col={12} sm={12} md={2}>
                  <AlignButtonSearch>
                    <FormGroup>
                      <Button
                        type="submit"
                        color="success"
                        onClick={() => {
                          loadUsers();
                        }}
                      >
                        Pesquisar
                      </Button>
                    </FormGroup>
                  </AlignButtonSearch>
                </Col>
              </Row>
            </form>
          </SearchRow>
          <TableContent>
            <Table hover>
              <thead>
                <tr>
                  <th>@</th>
                  <th>Nome</th>
                  <th>Email</th>
                  <th>Celular</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {users &&
                  users.map((user: any) => {
                    return (
                      <LineTable
                        key={user.id_srcprf}
                        active={!user.deleted}
                        onClick={() => handleClick(user.id_srcprf)}
                      >
                        <CellLine>{user.nickname_srcprf}</CellLine>
                        <CellLine> {user.name} </CellLine>
                        <CellLine>{user.email_srcprf}</CellLine>
                        <CellLine>{user.phone_number}</CellLine>
                        <CellLine>{user.deleted ? "Excluido" : ""}</CellLine>

                        <CellLine>
                          <RowEdit>
                            <FiPlus
                              size={25}
                              color="#a09e95"
                              onClick={() => {}}
                            />
                          </RowEdit>
                        </CellLine>
                      </LineTable>
                    );
                  })}
              </tbody>
            </Table>
          </TableContent>
        </div>
      </Container>
    </>
  );
};
